module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/unblock-9d7f54983a4205532cb11153efa31a59.svg";